<template>
  <div>
    <modal @close="onCancel">
      <h3 slot="header">{{ user.username }}</h3>
      <h4 slot="header">{{ user.name }}  {{ user.surnames }}</h4>
      <h5 slot="header">{{ user.email }}</h5>
      <div slot="body">
        <slot
          name="extra">
          <p><span class="bold">{{$t('health.patient.objective')}}:</span> {{ getObjective }}</p>
          <grid-row column-align="left">
            <grid-col col-size="2">
              <p><span class="bold">{{$t('health.patient.sex')}}:</span> {{ getSex }}</p>
            </grid-col>
            <grid-col col-size="2">
              <p><span class="bold">{{$t('health.patient.birthday')}}:</span> {{ user.birthday }}</p>
            </grid-col>
          </grid-row>

          <grid-row column-align="left">
            <grid-col col-size="2">
              <p><span class="bold">{{$t('health.patient.height')}}:</span> <span v-if="user.height">{{ user.height }}cm</span></p>
            </grid-col>
            <grid-col col-size="2">
              <p><span class="bold">{{$t('health.patient.weight')}}:</span> <span v-if="user.weight">{{ user.weight }}kg</span></p>
            </grid-col>
          </grid-row>

          <grid-row column-align="left">
            <grid-col col-size="2">
              <p><span class="bold">{{$t('health.patient.weeklyTrainings')}}:</span> <span v-if="user.weekly_trainings">{{ user.weekly_trainings }}</span></p>
            </grid-col>
            <grid-col col-size="2">
              <p><span class="bold">{{$t('health.patient.averageTrainingTime')}}:</span> <span v-if="user.average_training_time">{{ user.average_training_time }}min</span></p>
            </grid-col>
          </grid-row>
          <p v-if="user.objective_weight"><span class="bold">{{$t('health.patient.objectiveWeight')}}:</span> <span v-if="user.objective_weight">{{ user.objective_weight }}kg</span></p>
          <p class="bold">{{$t('health.patient.integrations')}}</p>
          <ul v-for="(integration, index) in user.integrations"
              :key="index">
            <li>{{ integration }}</li>
          </ul>
          <div v-has-feature="'Ring'"class="nav-buttons">
            <span class="nav-btn" @click="$router.push({ path: '/calendar', query: { id: user.id }})">
              {{ $t('health.patient.firstOption') }}
            </span>
            <span class="nav-btn nav-btn--disabled">
              {{ $t('health.patient.secondOption') }}
            </span>

            <span class="nav-btn" @click="$router.push({ path: '/nutritionistNotes', query: { id: user.id }})">
              {{ $t('health.patient.thirdOption') }}
              </span>
          </div>
        </slot>
      </div>
    </modal>
  </div>
</template>

<script>

import BtnPill from '@/components/shared/buttons/BtnPill';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import Modal from '@/components/shared/dialogs/Modal';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';


export default {
  components: {
    BtnPill,
    LabelSelect,
    Modal,
    GridRow,
    GridCol
  },
  props: {
    user: {
      type: Object
    }
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  computed: {
    getSex () {
      if (this.user.sex === null) {
        return '';
      }
      if (this.user.sex.toString() === '1') {
        return this.$t('health.patient.sexType.masculine');
      } else if (this.user.sex.toString() === '2') {
        return this.$t('health.patient.sexType.feminine');
      } else {
        return '';
      }
    },
    getObjective () {
      if (this.user.objective === null) {
        return '';
      }
      switch (this.user.objective) {
        case 'Lose weight':
          return this.$t('health.patient.objectiveType.loseWeight');
        case 'Gain muscle mass':
          return this.$t('health.patient.objectiveType.gainMuscleMass');
        case 'Improve sport performance':
          return this.$t('health.patient.objectiveType.improveSportPerformance');
        case 'Learn to eat better':
          return this.$t('health.patient.objectiveType.learnToEatBetter');
        case 'Improve rest quality':
          return this.$t('health.patient.objectiveType.improveRestQuality');
        case 'Feel more energetic':
          return this.$t('health.patient.objectiveType.feelMoreEnergetic');
        default:
          return this.user.objective;
      }
    }
  },
  methods: {
    onCancel (event) {
      this.$emit('close', event);
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 27:
          this.$emit('close', event);
          break;
      }
    }
  }
};

</script>

<style scoped lang="scss">
@import "src/stylesheets/variables";
.bold {
  font-weight: bold;
}

.nav-buttons {
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-top: 16px;
}

.nav-btn {
  display: block;
  color: $primary;
  font-weight: bold;
  font-size:1.7rem;
  cursor: pointer;
  background: none;
  border: none;
  padding: 4px 0;
  text-align: left;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }

  &--disabled {
    color: $primary;
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/patients/PatientDataModal.vue